import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromManagerCompaniesReducer from '@appStore/managers/reducers/manager-companies.reducer';
import * as fromManagerRolesReducer from '@appStore/managers/reducers/manager-roles.reducer';
import * as fromManagerCompanyInvitaionReducer from '@appStore/managers/reducers/manager-company-invitation.reducer';
import * as fromManagerCustomersReducer from '@appStore/managers/reducers/manager-customers.reducer';
import * as fromManagersTableReducer from '@appStore/managers/reducers/managers-table.reducer';

import * as fromRoot from '../../../reducers';

// feature state
export interface ManagersState {
  managerCompanies: fromManagerCompaniesReducer.State;
  managerRoles: fromManagerRolesReducer.State;
  managerCompanyInvitations: fromManagerCompanyInvitaionReducer.State;
  managerCustomers: fromManagerCustomersReducer.State;
  managersTable: fromManagersTableReducer.State;
}

export interface State extends fromRoot.State {
  managers: ManagersState;
}

// reducers
export const reducers: ActionReducerMap<ManagersState> = {
  managerCompanies: fromManagerCompaniesReducer.reducer,
  managerRoles: fromManagerRolesReducer.reducer,
  managerCompanyInvitations: fromManagerCompanyInvitaionReducer.reducer,
  managerCustomers: fromManagerCustomersReducer.reducer,
  managersTable: fromManagersTableReducer.reducer
};

// Managers
export const getState = createFeatureSelector<ManagersState>('managers');

export const getManagerCompaniesState = createSelector(
  getState,
  (state: ManagersState) => state.managerCompanies
);
export const getManagerCompanies = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getManagerCompanies
);
export const getNumberOfManagerCompanies = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getNumberOfManagerCompanies
);
export const getManagerCompaniesLoaded = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getManagerCompaniesLoaded
);
export const getManagerCompanySelected = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getManagerCompanySelected
);

// MangerCompany
export const getManagerCompanySelectedTab = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getManagerCompanySelectedTab
);

// ManagerCompany Customers
export const getManagerCompanyCustomers = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getManagerCompanyCustomers
);
export const getManagerCompanyCustomersLoaded = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getManagerCompanyCustomersLoaded
);

// ManagerCompany - A Users Customers
export const getManagerCompanyUserCustomers = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getManagerCompanyUserCustomers
);
export const getManagerCompanyUserCustomersLoaded = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getManagerCompanyUserCustomersLoaded
);

export const getManagerCompanyCustomersSelected = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getManagerCompanyCustomersSelected
);

// ManagerCompany Users
export const getManagerCompaniesUsers = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getManagerCompaniesUsers
);
export const getManagerCompaniesUsersLoaded = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getManagerCompaniesUsersLoaded
);

export const getManagerCompanyUserSelected = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getManagerCompanyUserSelected
);
export const getManagerCompanyUserUpdated = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getManagerCompanyUserUpdated
);
export const getBulkManagerCompanyUser = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getBulkManagerCompanyUser
);
export const getBulkManagerCompanyUserUpdated = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getBulkManagerCompanyUserUpdated
);
export const getManagerCompanyUserLockedForDelete = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getManagerCompanyUserLockedForDelete
);
export const getManagerCompanyUserLockedForDeleteLoaded = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getManagerCompanyUserLockedForDeleteLoaded
);

export const getManagerCompanyRemoved = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getManagerCompanyRemoved
);

export const getIsManagerCompanyUserExclusiveAdministrator = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getIsManagerCompanyUserExclusiveAdministrator
);

export const getIsManagerCompanyUserExclusiveAdministratorLoaded = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getIsManagerCompanyUserExclusiveAdministratorLoaded
);

export const getIsManagerCompanyUserLockedForUpdate = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getIsManagerCompanyUserLockedForUpdate
);

export const getIsManagerCompanyUserLockedForUpdateLoaded = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getIsManagerCompanyUserLockedForUpdateLoaded
);

export const getManagerCompanyUsersLockedForUpdate = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getManagerCompanyUsersLockedForUpdate
);

export const getManagerCompanyUsersLockedForUpdateLoaded = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getManagerCompanyUsersLockedForUpdateLoaded
);

export const getLockedManagerUsers = createSelector(
  getManagerCompaniesState,
  fromManagerCompaniesReducer.getLockedManagerUsers
);

// Manager Roles
export const getManagerRolesState = createSelector(
  getState,
  state => state.managerRoles
);
export const getManagerRoles = createSelector(
  getManagerRolesState,
  fromManagerRolesReducer.getManagerRoles
);
export const getManagerRolesLoaded = createSelector(
  getManagerRolesState,
  fromManagerRolesReducer.getManagerRolesLoaded
);

// ManagerCompany Invitation State
export const getManagerCompanyInvitationState = createSelector(
  getState,
  state => state.managerCompanyInvitations
);
// ManagerCompany Invitation Created
export const getManagerCompanyInvitationCreated = createSelector(
  getManagerCompanyInvitationState,
  fromManagerCompanyInvitaionReducer.getManagerCompanyInvitationCreated
);

// ManagerCompany Invitations
export const getManagerCompanyInvitations = createSelector(
  getManagerCompanyInvitationState,
  fromManagerCompanyInvitaionReducer.getManagerCompanyInvitations
);
export const getManagerCompanyInvitationsLoaded = createSelector(
  getManagerCompanyInvitationState,
  fromManagerCompanyInvitaionReducer.getManagerCompanyInvitationsLoaded
);

// ManagerCustomers
export const getManagerCustomerState = createSelector(
  getState,
  (state: ManagersState) => state.managerCustomers
);
export const getManagerCustomerSelected = createSelector(
  getManagerCustomerState,
  fromManagerCustomersReducer.getManagerCustomerSelected
);
export const getManagerCustomersSelected = createSelector(
  getManagerCustomerState,
  fromManagerCustomersReducer.getManagerCustomersSelected
);
export const getManagerCustomerUsers = createSelector(
  getManagerCustomerState,
  fromManagerCustomersReducer.getManagerCustomerUsers
);
export const getManagerCustomerUsersLoaded = createSelector(
  getManagerCustomerState,
  fromManagerCustomersReducer.getManagerCustomerUsersLoaded
);
export const getManagerCustomerUserSelected = createSelector(
  getManagerCustomerState,
  fromManagerCustomersReducer.getManagerCustomerUserSelected
);


export const getManagerCustomersUsers = createSelector(
  getManagerCustomerState,
  fromManagerCustomersReducer.getManagerCustomersUsers
);
export const getManagerCustomersUsersLoaded = createSelector(
  getManagerCustomerState,
  fromManagerCustomersReducer.getManagerCustomersUsersLoaded
);

// ManagerCustomers MeteringPoints
export const getManagerCustomerMeteringPoints = createSelector(
  getManagerCustomerState,
  fromManagerCustomersReducer.getManagerCustomerMeteringPoints
);
export const getManagerCustomermeteringPointsLoaded = createSelector(
  getManagerCustomerState,
  fromManagerCustomersReducer.getManagerCustomerMeteringPointsLoaded
);

export const getMeteringPointsWithAdresses = createSelector(
  getManagerCustomerMeteringPoints,
  meteringPoints => {
    return meteringPoints.map(mp => {
      return {
        ...mp,
        addressLabel:
          !mp.addresses || mp.addresses.length === 0
            ? '(Ingen Adress)'
            : mp.addresses[0].street + ' ' + mp.addresses[0].streetNo
      };
    });
  }
);

export const getManagerUsersToCustomerAdded = createSelector(
  getManagerCustomerState,
  fromManagerCustomersReducer.getManagerUsersToCustomerAdded
);

export const getManagerCustomerUserUpdated = createSelector(
  getManagerCustomerState,
  fromManagerCustomersReducer.getManagerCustomerUserUpdated
);

// BulkUpdate
export const getCustomersForManagerUserUpdated = createSelector(
  getManagerCustomerState,
  fromManagerCustomersReducer.getCustomersForManagerUserUpdated
);
// BulkRemove, BulkUpdate, BulkAdd
export const getLockManagerCustomerUsersForUpdateLoaded = createSelector(
  getManagerCustomerState,
  fromManagerCustomersReducer.getLockManagerCustomerUsersForUpdateLoaded
);
export const getLockManagerCustomerUsersForUpdate = createSelector(
  getManagerCustomerState,
  fromManagerCustomersReducer.getLockManagerCustomerUsersForUpdate
);

export const getManagerCustomerRemoved = createSelector(
  getManagerCustomerState,
  fromManagerCustomersReducer.getManagerCustomerRemoved
);
export const getManagerCustomerUserRemoved = createSelector(
  getManagerCustomerState,
  fromManagerCustomersReducer.getManagerCustomerUserRemoved
);

// MaangersTable
export const getManagersTableState = createSelector(
  getState,
  state => state.managersTable
);

export const getManagerUsersPageData = createSelector(
  getManagersTableState,
  fromManagersTableReducer.getManagerUsersTableState
);

export const getManagerInvitationsPageData = createSelector(
  getManagersTableState,
  fromManagersTableReducer.getManagerInvitationsTableState
);

export const getManagerCustomerUsersPageData = createSelector(
  getManagersTableState,
  fromManagersTableReducer.getManagerCustomerUsersTableState
);

export const getManagerCustomersPageData = createSelector(
  getManagersTableState,
  fromManagersTableReducer.getManagerCustomersTableState
);

export const getManagerUserCustomersPageData = createSelector(
  getManagersTableState,
  fromManagersTableReducer.getManagerUserCustomersTableState
);
